'use client';

import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo
} from 'react';
import { Conditional, Toast } from 'components/pcc-components';
import { useToast } from './use-toast';

const ToastContext = createContext(null);

/**
 * Provides quick access to a success or error toast message
 */
export const useQuickToast = () => useContext(ToastContext);

export const ToastProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    success,
    error,
    warning,
    showToast,
    closeToast,
    toasts,
    delay,
    position,
    className
  } = useToast();
  const availableToastMethods = useMemo(
    () => ({ success, error, warning }),
    [success, error, warning]
  );

  return (
    <ToastContext.Provider value={availableToastMethods}>
      <Conditional test={showToast}>
        <Toast
          onToastClose={closeToast}
          toasts={toasts}
          delay={delay}
          position={position}
          className={className}
        />
      </Conditional>
      {children}
    </ToastContext.Provider>
  );
};
